import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format number as INR with commas
export function formatINR(amount) {
  if (amount === null || amount === undefined) return "₹0";
  
  const num = Math.round(amount);
  const numStr = num.toString();
  
  // Indian numbering system: last 3 digits, then groups of 2
  if (numStr.length <= 3) {
    return `₹${numStr}`;
  }
  
  let result = numStr.slice(-3);
  let remaining = numStr.slice(0, -3);
  
  while (remaining.length > 0) {
    const chunk = remaining.slice(-2);
    result = chunk + "," + result;
    remaining = remaining.slice(0, -2);
  }
  
  return `₹${result}`;
}

// Format date string
export function formatDate(dateStr) {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
}

// Export leads to CSV
export function exportToCSV(leads, filename = "leads.csv") {
  const headers = ["Name", "Phone", "Email", "Event Date", "Notes", "Grand Total", "Created At"];
  
  const rows = leads.map(lead => [
    lead.name,
    lead.phone,
    lead.email,
    lead.event_date || "",
    lead.notes || "",
    lead.estimate_snapshot?.grand_total || 0,
    lead.created_at
  ]);
  
  const csvContent = [
    headers.join(","),
    ...rows.map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(","))
  ].join("\n");
  
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
}
